import React from 'react';
import { Link } from 'react-router-dom';

export default class FormLists extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            loaded: false,
            error: false,
            lists: []
        }
    }
    componentDidMount()
    {
        this.loadOrgLists();
    }
    loadOrgLists()
    {
        this.props.api.send({
            controller: "List",
            action: "GetMyLists",
            method: "get",
            success: (response) => {
                response.success ?
                    this.setState({loaded: true, lists: response.lists}) :
                    this.setState({loaded: true, error: true})
            },
            error: (err) => {
                this.setState({loaded: true, error: true})
            }
        })
    }
    
    render()
    {
        const lists = this.state.lists.map((l, lidx) => 
            <tr key={l.lidx}>
                <td>{l.name}</td>
                <td>{l.linkedList !== null ? l.linkedList.name : ""}</td>
                <td><Link to={"/Lists/edit/" + l.listID} className="lmsbutton">Edit</Link></td>
            </tr>
        )
        return (
            <div style={{marginTop: "10px"}}>
                <strong>Lists</strong>
                {this.state.loaded ?
                    this.state.lists.length > 0 ? (
                        <div>
                            <table className="lmstable">
                                <tbody>
                                    <tr>
                                        <th>Name</th>
                                        <th>Linked List</th>
                                        <th style={{width: "50px"}}></th>
                                    </tr>
                                    {lists}
                                </tbody>
                            </table>                            
                        </div>
                    ) : (
                    <p>
                        <i>You do not currently have any lists available. Use the button below to create and start managing your lists.</i>
                    </p>
                ) : (
                    <div className="lmscenter"><img src="/images/spinner.svg" alt="Loading..." /></div>
                )}
                <Link to={"/Lists/new"} className="lmsbutton">Create List</Link>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/lists/formlists.js